<template>
    <v-card outlined>
        <v-btn
            class="text-capitalize back-button transition-all"
            :class="[!newCampaign.category && 'invisible']"
            depressed
            elevation="0"
            fab
            color="#757575"
            icon
            @click="detachCategory()"
        >
            <v-icon size="45" v-text="icons.mdiArrowLeft"></v-icon>
        </v-btn>
        <v-card-title
            class="subtitle-3 d-flex justify-center text-center"
            style="word-break: normal"
        >
            <span class="text-h4">
                {{ translations.selectCategory[lang] }}</span
            >
        </v-card-title>
        <v-card-actions class="subtitle-2" style="word-break: normal;">
            <v-row class="d-flex justify-center flex-column align-center mt-10">
                <v-row class="d-flex justify-center transition-all mw-100">
                    <v-skeleton-loader
                        v-if="
                            loading ||
                                !campaignTypes ||
                                u.isEmpty(campaignTypes)
                        "
                        class="d-flex justify-center transition-all mw-100 campaign-actions category-loader"
                        :types="{ actions: 'button@3' }"
                        type="actions"
                    ></v-skeleton-loader>

                    <v-col
                        v-else
                        v-for="(item, index) in campaignTypes"
                        :key="index"
                        cols="12"
                        sm="12"
                        md="3"
                        class="rounded-xl d-flex flex-column justify-center align-center ma-5 mt-0 pa-6 pt-5 pb-5 select-category transition-all"
                        :class="[newCampaign.category && 'invisible']"
                        @click="attachCategory(index)"
                    >
                        <v-sheet
                            class="border-grey rounded-circle icon-container"
                        >
                            <v-icon
                                class="ma-4"
                                size="110"
                                v-text="icons[index]"
                            ></v-icon>
                        </v-sheet>
                        <div class="pa-3 text-center pr-0 pl-0 mw-180 ">
                            {{ translations[index][lang] }}
                        </div>
                    </v-col>
                </v-row>
                <v-row
                    v-if="selectedCategory.campaign_types && selectedCategory.campaign_types.length !== 1"
                    class="d-flex justify-center overlapped transition-all mw-100"
                    :class="[!newCampaign.category && 'invisible']"
                >
                    <v-col
                        v-for="(item, index) in selectedCategory.campaign_types"
                        :key="index"
                        cols="12"
                        sm="12"
                        :md="
                            parseInt(
                                12 /
                                    (1 + selectedCategory.campaign_types.length)
                            ) + ''
                        "
                        class="rounded-xl d-flex flex-column justify-center align-center ma-5 mt-0 pa-10 pt-5 pb-5 select-category transition-all"
                        @click="attachType(item.campaign_type_id, item.system)"
                    >
                        <!-- index{{ index }} -->
                        <v-sheet
                            class="border-grey rounded-circle icon-container"
                        >
                            <v-icon
                                class="ma-4"
                                size="110"
                                v-text="icons[item.system] || icons.default"
                            ></v-icon>
                        </v-sheet>
                        <div v-if="translations['type_' + item.system]" class="pa-3 text-center pr-0 pl-0 mw-180">
                            {{ translations["type_" + item.system][lang] }}
                        </div>
                    </v-col>
                </v-row>
            </v-row>
        </v-card-actions>
    </v-card>
</template>

<script>
import {
    mdiArrowLeft,
    mdiArrowRight,
    mdiBullhorn,
    mdiCalendarRefresh,
    mdiCartArrowDown,
    mdiCashPlus,
    mdiCalendar,
    mdiCalendarMultiple,
    mdiAccountArrowRight,
    mdiBasketUnfill,
    mdiAlphaGCircleOutline,
    mdiBullseyeArrow
} from "@mdi/js";
import { mapMutations, mapState, mapActions } from "vuex";
import translations from "@/utils/translations/loyaltyPanel/campaigns/newCampaign";
import _ from "lodash";

export default {
    name: "Step1",

    mixins: [translations],

    data: () => ({
        icons: {
            informative: mdiBullhorn,
            action: mdiAccountArrowRight,
            draw: mdiBasketUnfill,
            one_time_execution: mdiCalendar,
            repeat_execution: mdiCalendarRefresh,
            multiple_times_execution: mdiCalendarMultiple,
            new_transaction: mdiCashPlus,
            transaction_with_specific_products: mdiCartArrowDown,
            transaction_goal: mdiBullseyeArrow,
            default: mdiAlphaGCircleOutline,
            mdiArrowLeft
        },
        u: _,
        disableBtn: true
    }),

    computed: {
        ...mapState("loyaltyPanel/campaigns/newCampaign", ["campaignTypes", "step"]),
        ...mapState(["loading"]),
        lang() {
            return this.$route.params.lang;
        },

        selectedCategory() {
            return this.campaignTypes[this.newCampaign.category] || {};
        },

        newCampaign: {
            get() {
                return this.$store.state.loyaltyPanel.campaigns.newCampaign
                    .newCampaign;
            },
            set(val) {
                this.setNewCampaign(val);
            }
        }
    },

    methods: {
        ...mapMutations("loyaltyPanel/campaigns/newCampaign", [
            "setNewCampaign",
            "setCanGoToNextStep",
            "setStep"
        ]),
        attachCategory(val) {
            this.$set(this.newCampaign, "category", val);
            if (this.campaignTypes[val]?.campaign_types?.length === 1) {
                let type = this.campaignTypes[val]?.campaign_types?.[0]
                if(type.options.length === 0){
                    this.setStep(2)
                }
                this.attachType(type.campaign_type_id, type.system)
            }
        },

        detachCategory() {
            this.$set(this.newCampaign, "category", undefined);
            this.$set(this.newCampaign, "campaign_type_id", undefined);
            this.$set(this.newCampaign, "campaign_type_system", undefined);
        },

        attachType(id, system) {
            this.$set(this.newCampaign, "campaign_type_id", id);
            this.$set(this.newCampaign, "campaign_type_system", system);
            this.setCanGoToNextStep(false);
            this.$emit("next");
        }
    },
    watch: {
        step: {
            immediate: true,
            deep: true,
            handler(val) {
               if (this.newCampaign.category =='draw' && this.step === 1) {
                    this.detachCategory()
               }
            }
        },
    }
};
</script>

<style>
.campaign-actions .v-skeleton-loader__actions {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: stretch;
    min-height: 42px;
}
.campaign-actions.category-loader .v-skeleton-loader__actions {
    height: 300px;
}
.campaign-actions .v-skeleton-loader__actions .v-skeleton-loader__button {
    height: auto;
    width: auto;
    min-width: 64px;
    width: 100%;
}

.campaign-actions.category-loader
    .v-skeleton-loader__actions
    .v-skeleton-loader__button {
    width: 400px;
    border-radius: 24px;
    margin-right: 40px !important;
}

.campaign-actions
    .v-skeleton-loader__actions
    .v-skeleton-loader__button:last-child {
    margin-right: 0 !important;
}
</style>

<style scoped>
.border-grey {
    border: 2px solid grey;
}

.b-outlined {
    border: 1px solid rgba(0, 0, 0, 0.12);
}

.icon-container {
    /* margin-top:20px; */
    height: 150px;
    width: 150px;
}
.select-category {
    cursor: pointer;
    transition: all 0.5s ease-out;
    background-color: white;
    min-width: 200px;
    font-size: 22px;
    color: gray;
    /* border: 1px solid black */
}
.select-category:hover {
    background-color: rgba(0, 0, 0, 0.2);
    color: black;
    /* font-size: 26px; */
}

.invisible {
    opacity: 0;
    z-index: 0;
}

.overlapped {
    position: absolute;
}

.transition-all {
    transition: all 1.5s, width 2s, max-width 1s, min-width 1s, margin-left 2s,
        margin-top 2.5s, background-position 1.5s, opacity 1s,
        background-color 2s;
}
.back-button {
    position: absolute;
    top: 45%;
    z-index: 10;
}
.mw-100 {
    min-width: 100% !important;
}
.mw-180 {
    min-width: 180px !important;
}
.display-none {
    display: none !important;
}
</style>
